import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_URL = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_URL,
});

api.interceptors.request.use((cfg) => {
    const token = localStorage.getItem("clonzo_token");
    if (token) cfg.headers.Authorization = `Bearer ${token}`;
    return cfg;
});
